export function convertUtcToEst(time: string): string {
  if (time == null) {
    return "";
  }
  const date = new Date(time).toLocaleString("en-US", {
    timeZone: "America/New_York",
  });
  return date + " EST";
}
